import { useNavigate } from "react-router-dom";
import { useLazyGetApplicationDataToBankQuery } from "../../../../store/api/applicationBankApi/applicationBank.api";
import { useAppSelector } from "../../../../store/reduxHooks";
import { APPLICATION_BANK_STATUS_KKB } from "../../../../utils/guards/ApplicationBankStatusGuard/types";
import { Button, message } from "antd";
import { ApplicationStatusBaseInfo } from "../../../Ui/Application/ApplicationStatusBaseInfo/ApplicationStatusBaseInfo";
import classes from "../BankCredit.module.css";
import { SELECT_REQUEST_BANK_ID } from "../../../../store/selectors/requestAppSelector";
import { ApplicationCommissionInfo } from "../../../Ui/Application/ApplicationCommissionInfo/ApplicationComissionInfo";
import { IApplicationComissionInfoProps } from "../../../../interfaces/Ui/Application/IApplicationComissionInfoProps/IApplicationComissionInfoProps";

export const ModifiedBankContent = () => {
  const data = useAppSelector(SELECT_REQUEST_BANK_ID);
  const navigate = useNavigate();
  const activeBankInfo = useAppSelector(
    (state) => state.requestAppSlise.data.bank,
  );
  const bankRate = data?.bank_rate ? data?.bank_rate : data?.bank?.base_rate;

  const applicationId = activeBankInfo.application_id;

  const applicationBankId = activeBankInfo.id;

  const [getApplicationInfoTrigger, { isLoading: isApplicationInfoLoading }] =
    useLazyGetApplicationDataToBankQuery();

  const openAdditionalForm = async () => {
    try {
      await getApplicationInfoTrigger({
        applicationId: Number(applicationId),
        applicationBankId: Number(applicationBankId),
      }).unwrap();
      navigate(
        `/system-bank/create-data-to-bank/${applicationId}/application-bank/${applicationBankId}`,
      );
    } catch (error: any) {
      message.error(error.data.message);
    }
  };

  const info = {
    overstatement: data.overstatement ? +data.overstatement : 0,
    base_commission: +data.base_commission,
    bank_commission: data.overstatement
      ? +data.overstatement + +data.base_commission
      : data.base_commission,
  };

  const fields: IApplicationComissionInfoProps["fields"] = [
    { name: "Тариф банка", value: `${info.base_commission} ₽` },
    { name: "Ставка", value: `${bankRate} %` },
    { name: "Завышение", value: `${info.overstatement} ₽` },
    { name: "Итоговая комиссия", value: `${info.bank_commission} ₽` },
  ];

  if (
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_KKB.PROCESSING ||
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_KKB.DIRECTED ||
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_KKB.SIGNING ||
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_KKB.RESIGNING ||
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_KKB.OFFER ||
    activeBankInfo.status.type === APPLICATION_BANK_STATUS_KKB.REFUSAL
  ) {
    return (
      <div className={classes.bankInfoWithAddFormContainer}>
        <ApplicationStatusBaseInfo
          className={classes.applicationStatusInfo}
          appNumber={activeBankInfo.id}
          status={activeBankInfo.status.title}
        />

        <Button
          className={classes.addFormButton}
          variant="solid"
          color="primary"
          disabled={isApplicationInfoLoading}
          loading={isApplicationInfoLoading}
          onClick={openAdditionalForm}
        >
          Дополнительная форма
        </Button>
      </div>
    );
  }

  return (
    <div className={classes.bankInfoWithAddFormContainer}>
      <ApplicationCommissionInfo
        className={classes.comissionContainer}
        fields={fields}
      />

      <Button
        className={classes.addFormButton}
        variant="solid"
        color="primary"
        disabled={isApplicationInfoLoading}
        loading={isApplicationInfoLoading}
        onClick={openAdditionalForm}
      >
        Дополнительная форма
      </Button>
    </div>
  );
};
